import { CommissionsPayload, CommissionsSummaryPayload } from './common-types/types-commissions';

export const commissionsPayloadToCommissionsSummaryPayload = (
  payload: CommissionsPayload
): CommissionsSummaryPayload => {
  const { filters, ...rest } = payload;
  const productNameQuery = filters?.find((item) => item.key === 'productName')?.value || '';
  return { ...rest, states: rest.states.toString(), productNameQuery };
};
